var _path, _mask, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1.77783C14.6569 1.77783 16 3.12098 16 4.77784V10.3334C16 11.8177 14.9221 13.0502 13.5063 13.2908L13.4107 15.5265C13.377 16.3121 12.4916 16.7533 11.8441 16.3071L7.52893 13.3334H3.88889C2.23203 13.3334 0.888889 11.9902 0.888889 10.3334V4.77783C0.888889 3.12098 2.23203 1.77783 3.88889 1.77783H13Z",
    fill: "#D61D4F"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_158_2750",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V8.55556C0 10.0398 1.07792 11.2724 2.49366 11.513L2.58934 13.7486C2.62296 14.5343 3.50837 14.9755 4.15586 14.5293L8.47107 11.5556H12.1111C13.768 11.5556 15.1111 10.2124 15.1111 8.55555V3C15.1111 1.34315 13.768 0 12.1111 0H3Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V8.55556C0 10.0398 1.07792 11.2724 2.49366 11.513L2.58934 13.7486C2.62296 14.5343 3.50837 14.9755 4.15586 14.5293L8.47107 11.5556H12.1111C13.768 11.5556 15.1111 10.2124 15.1111 8.55555V3C15.1111 1.34315 13.768 0 12.1111 0H3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49366 11.513L3.49274 11.4702L3.45818 10.6626L2.66123 10.5271L2.49366 11.513ZM2.58934 13.7486L1.59025 13.7914V13.7914L2.58934 13.7486ZM4.15586 14.5293L4.7233 15.3527H4.7233L4.15586 14.5293ZM8.47107 11.5556V10.5556H8.15987L7.90362 10.7321L8.47107 11.5556ZM1 3C1 1.89543 1.89543 1 3 1V-1C0.790859 -1 -1 0.790866 -1 3H1ZM1 8.55556V3H-1V8.55556H1ZM2.66123 10.5271C1.71815 10.3668 1 9.54407 1 8.55556H-1C-1 10.5356 0.437692 12.1779 2.32608 12.4989L2.66123 10.5271ZM3.58842 13.7059L3.49274 11.4702L1.49457 11.5558L1.59025 13.7914L3.58842 13.7059ZM3.58842 13.7059L3.58842 13.7059L1.59025 13.7914C1.6575 15.3627 3.42833 16.2451 4.7233 15.3527L3.58842 13.7059ZM7.90362 10.7321L3.58842 13.7059L4.7233 15.3527L9.03851 12.379L7.90362 10.7321ZM12.1111 10.5556H8.47107V12.5556H12.1111V10.5556ZM14.1111 8.55555C14.1111 9.66012 13.2157 10.5556 12.1111 10.5556V12.5556C14.3203 12.5556 16.1111 10.7647 16.1111 8.55555H14.1111ZM14.1111 3V8.55555H16.1111V3H14.1111ZM12.1111 1C13.2157 1 14.1111 1.89543 14.1111 3H16.1111C16.1111 0.790861 14.3203 -1 12.1111 -1V1ZM3 1H12.1111V-1H3V1Z",
    fill: "#FA9418",
    mask: "url(#path-2-inside-1_158_2750)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.c985a6c4cd7281d0ad98d2de6e68597c.svg";
export { ForwardRef as ReactComponent };